import React, { useState, useEffect } from "react";
import "../CSS/Login.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "../../assets/icone.png";

const Login = () => {
  const navigate = useNavigate();


    const handleNavigation = (destination) => {
 // alert("Navigate to:", destination);

    // Replace these with your React Router routes:
    //
     navigate(`/${destination}`);
    // navigate("/agent-login");
    // navigate("/employer");
    // navigate("/opportunities");
  };


  const [formData, setFormData] = useState({
    systemCode: "",
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};


    if (!formData.email.trim()) {
      newErrors.email = "Email address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    if (!formData.password) {
      newErrors.password = "Password is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
 

        const response = await fetch(
          "https://advenwarecareerlink.com/acl/My_account/Log_in.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message);
        }

        if(result.message !== 'available')
        {
          alert('invalid details please check your input fields or create an account')
          return
        }

         const login = () => {
          Cookies.set("userID", `${result.ID}`, {
            expires: 7 * 42
         });

        
       };

       login()

       // alert(result.user_ID)

    

    //  console.log("Login details:", formData);

      await new Promise((resolve) =>
        setTimeout(resolve, 1200)
      );

      handleNavigation('/')

    } catch (error) {
      console.error(error);
      alert("Unable to login. Please check your details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      {/* ==================================================
          LEFT SIDE
      ================================================== */}

      <section className="login-hero">

        <div className="login-grid"></div>

        <div className="login-hero-content">

          {/* BRAND */}

          <div className="login-brand">

               <img
                                        src={logo}
                                        alt="Advenware Career Link"
                                        className="landing-logo-image"
              />

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HERO MESSAGE */}

          <div className="login-message">

            <div className="login-badge">
              WELCOME BACK
            </div>

            <h1>
              Your next
              <span> opportunity </span>
              starts here.
            </h1>

            <p>
              Sign in to your Advenware Careere Link account
              and continue connecting students with meaningful
              attachment opportunities.
            </p>


            <div className="login-feature-list">

              <div className="login-feature">

                <div className="feature-check">
                  ✓
                </div>

                <div>
                  <strong>
                    Access your profile
                  </strong>

                  <span>
                    Manage your information and preferences.
                  </span>
                </div>

              </div>


              <div className="login-feature">

                <div className="feature-check">
                  ✓
                </div>

                <div>
                  <strong>
                    Manage opportunities
                  </strong>

                  <span>
                    Track attachment opportunities and applications.
                  </span>
                </div>

              </div>


              <div className="login-feature">

                <div className="feature-check">
                  ✓
                </div>

                <div>
                  <strong>
                    Stay connected
                  </strong>

                  <span>
                    Keep up with students and organizations.
                  </span>
                </div>

              </div>

            </div>

          </div>


          <div className="login-hero-footer">
            <span>
              © 2026 Advenware Careere Link
            </span>

            <span>
              Students • Organizations • Careers
            </span>
          </div>

        </div>

      </section>


      {/* ==================================================
          RIGHT SIDE
      ================================================== */}

      <section className="login-form-area">

        <div className="login-form-wrapper">

          {/* MOBILE BRAND */}

          <div className="mobile-login-brand">

            <div className="login-brand-icon">
              AC
            </div>

            <div>
              <h2>Advenware</h2>
              <p>Careere Link</p>
            </div>

          </div>


          {/* HEADER */}

          <div className="login-header">

            <div className="login-step">
              ACCOUNT ACCESS
            </div>

            <h1>
              Welcome back
            </h1>

            <p>
              Sign in to continue to your Advenware
              Careere Link account.
            </p>

          </div>


          <form onSubmit={handleSubmit}>

       


            {/* EMAIL */}

            <div className="login-input-group">

              <label>
                Email address <span>*</span>
              </label>

              <div className="login-input-container">

                <span className="login-input-icon">
                  @
                </span>

                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="email"
                />

              </div>

              {errors.email && (
                <small className="login-error">
                  {errors.email}
                </small>
              )}

            </div>


            {/* PASSWORD */}

            <div className="login-input-group">

              <div className="password-label-row">

                <label>
                  Password <span>*</span>
                </label>

                <button
                  type="button"
                  className="forgot-button"
                  onClick={() =>
                    console.log("Forgot password")
                  }
                >
                  Forgot password?
                </button>

              </div>

              <div className="login-input-container">

                <span className="login-input-icon">
                  ◆
                </span>

                <input
                  type={
                    showPassword
                      ? "text"
                      : "password"
                  }
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="show-password"
                  onClick={() =>
                    setShowPassword(!showPassword)
                  }
                >
                  {showPassword ? "Hide" : "Show"}
                </button>

              </div>

              {errors.password && (
                <small className="login-error">
                  {errors.password}
                </small>
              )}

            </div>


            {/* REMEMBER */}

            <div className="remember-row">

              <label className="remember">

                <input
                  type="checkbox"
                  defaultChecked
                />

                <span>
                  Remember me
                </span>

              </label>

              <div className="secure-login">
                <span>●</span>
                Secure login
              </div>

            </div>


            {/* LOGIN */}

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >

              {loading
                ? "Signing in..."
                : "Sign in to my account →"}

            </button>


            {/* CREATE ACCOUNT */}

            <div className="create-account">

              <span>
                Don't have an account?
              </span>

              <button
                type="button"
               onClick={() => handleNavigation("Create_account")}
              >
                Create account
              </button>

            </div>


            {/* DIVIDER */}

            <div className="login-divider">
              <span></span>
              <p>Advenware Careere Link</p>
              <span></span>
            </div>


            <p className="login-security-note">
              Your account information is protected and
              securely handled by Advenware Careere Link.
            </p>

          </form>

        </div>

      </section>

    </div>
  );
};

export default Login;